module.exports = __webpack_public_path__ + "img/Flag.a07b796e.png";